import { client } from '../client';
import { IGMRegisteredMedia } from './types/IGMRegisteredMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface RegisterMediaPayload {
  files: Array<{
    filename: string;
    mimetype: string;
    attributes?: { [x: string]: string };
  }>;
}

export const registersConversationMedia = async (
  conversationSid: string,
  payload: RegisterMediaPayload,
  userRole?: string,
): Promise<IGMRegisteredMedia> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IGMRegisteredMedia>(
    `${prefix}/conversations/${conversationSid}/media/register`,
    payload,
  );

  return data;
};
